<template>
  <span class="order-route-list">
    <Ellipsis :text="route" :length="20"/>
  </span>
</template>

<script>
export default {
  props: ['sources', 'destinations'],
  computed: {

    route() {
      const defaultLocation = { city: null, name: null };
      const { details: sourceDetail } = this.sources[0] || defaultLocation;
      const { details: destinationDetail } = this.destinations[0] || defaultLocation;
      const destinationpoint = destinationDetail.city || destinationDetail.name;
      const sourcePoint = sourceDetail.city || sourceDetail.name;
      return sourcePoint && destinationpoint && `${sourcePoint} - ${destinationpoint}`;
    },
  },

  data() {
    return {
      options: {
        placement: 'bottom',
        modifiers: {
          offset: {
            enabled: true,
            offset: '10,5',
          },
        },
      },
    };
  },
};
</script>

<style lang='scss'>
@import "~@common/styles-shipper/settings";
.order-route {
  &-popup {
    width: 100px;
    box-shadow: 0 6px 12px rgba(0,0,0,.05), 0 1px 4px rgba(0,0,0,.15);
    border: 0;
  }
  &-left-count {
    float: right;
    padding-right: 10px;
  }
  &-left-city {
    @extend %list-unstyled;
    padding: 10px;
    text-align: left;
    li{
      line-height: 22px;
      font-size: 1.2rem;
    }
  }
}

</style>
